// @ts-check
// Regras puras da atualização automática (contrato 08-contrato-navegacao-mobile.md, seção 6): o que reler, o que tirar
// das listas e quando recarregar a lista, a partir das mudanças do feed.

/**
 * @typedef {{ objectNameSingular: string, recordId: string, kind: string, workspaceMemberId: string | null }} RemoteChange
 */

/**
 * Agrupa as mudanças de outras pessoas por objeto: o que reler, o que tirar das listas e se há registro novo.
 * @param {RemoteChange[]} changes @param {string | null} ownWorkspaceMemberId
 */
export function groupRemoteChanges(changes, ownWorkspaceMemberId) {
  /** @type {Map<string, { updatedIds: Set<string>, removedIds: Set<string>, hasNewRecords: boolean }>} */
  const byObject = new Map();
  for (const change of changes) {
    // as próprias mudanças já estão na tela (atualização otimista)
    if (ownWorkspaceMemberId && change.workspaceMemberId === ownWorkspaceMemberId) continue;
    const entry = byObject.get(change.objectNameSingular) ?? { updatedIds: new Set(), removedIds: new Set(), hasNewRecords: false };
    if (change.kind === 'delete' || change.kind === 'destroy') {
      entry.removedIds.add(change.recordId);
      entry.updatedIds.delete(change.recordId);
    } else {
      if (change.kind === 'create' || change.kind === 'restore') entry.hasNewRecords = true;
      if (!entry.removedIds.has(change.recordId) || change.kind === 'restore') entry.updatedIds.add(change.recordId);
      if (change.kind === 'restore') entry.removedIds.delete(change.recordId);
    }
    byObject.set(change.objectNameSingular, entry);
  }
  return byObject;
}

/**
 * Ids relidos que não voltaram: com papel restrito por etapa, o registro foi para uma etapa que a pessoa não vê (ou
 * deixou de existir) e sai das listas (contrato de equipe, seção 3.2).
 * @param {string[]} requestedIds @param {Array<{ id: string }>} freshRecords
 * @returns {string[]}
 */
export function findVanishedIds(requestedIds, freshRecords) {
  const returned = new Set(freshRecords.map((record) => record.id));
  return requestedIds.filter((id) => !returned.has(id));
}
